import {Avatar, Box, Container, Grid} from '@material-ui/core'
import {DragIndicator} from '@material-ui/icons'
import ButtonLarge from 'src/components/Buttons/ButtonLarge'
import Styled from 'src/components/Styled'
import styles from './styles'

export const Root = Styled(Box, styles.root)
export const FormContainer = Styled(Box, styles.formContainer)
export const InnerContainer = Styled(Box, styles.innerContainer)
export const ButtonsBox = Styled(Box, styles.buttonsBox)
export const ButtonSave = Styled(ButtonLarge, styles.buttonSave)
export const ButtonCancel = Styled(ButtonLarge, styles.buttonCancel)
export const Thumbnail = Styled(Avatar, styles.thumbnail)

export const ActionCardContainer = Styled(Container, styles.actionCardContainer)
export const ActionCardHeader = Styled(Box, styles.actionCardHeader)
export const ActionCardHeaderDragIcon = Styled(DragIndicator, styles.actionCardHeaderDragIcon)
export const ActionCardContent = Styled(Box, styles.actionCardContent)
export const ActionCardThumbnail = Styled(Avatar, styles.actionCardThumbnail)
export const ActionCardDetails = Styled(Box, styles.actionCardDetails)
export const ActionDropTargetIndicator = Styled(Grid, styles.actionDropTargetIndicator)

export const DialogRoot = Styled(Box, styles.dialogRoot)
